import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {AuthService} from '../../../services/auth.service';
import {map, shareReplay} from 'rxjs/operators';
import { GridService } from 'src/app/services/grid.service';
import {ExportDiaglogComponent} from '../../../grid/dialogs/export-diaglog/export-diaglog.component';
import {MatDialog} from '@angular/material/dialog';
import {SharedService} from '../../../services/shared.service';
import {ImportDiaglogComponent} from '../../../grid/dialogs/import-diaglog/import-diaglog.component';
import {BulkEditDialogComponent} from '../../../grid/dialogs/bulk-edit-dialog/bulk-edit-dialog.component';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../services/http.service';
import {ToastService} from '../../../services/toast.service';
import {
  ExpressionsBuilderDialogComponent
} from '../../../grid/dialogs/expressions-builder-dialog/expressions-builder-dialog.component';
import {InfoService} from '../../../services/info.service';
import { WebSocketService } from 'src/app/services/web-socket.service';
import {RowNode, ServerSideTransaction, ServerSideTransactionResult} from 'ag-grid-community';
import {LocalStorageService} from '../../../services/local-storage.service';
import {ProgressBarsService} from '../../../services/progress-bars.service';
import {
  FilterFromFileDialogComponent
} from '../../../grid/dialogs/filter-from-file-dialog/filter-from-file-dialog.component';
import { ScheduleExportDialogComponent } from '../../../grid/dialogs/schedule-export-dialog/schedule-export-dialog.component';
import { SyncModeDialogComponent } from '../../../components/dialog/sync-mode-dialog/sync-mode-dialog.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public stageModifiedProductsCounter: number = 0;
  public disapproveCounter: number = 0;
  public productionModifiedProductsCounter: number = 0;
  public currentApplicationVersion = environment.appVersion;
  public user$: Observable<any>;
  public currentTable: any = {name: ''};
  public enableBottomBar: boolean = false;
  public showForceButton: boolean = false;
  public tableSelectorValue = [
    {
      id: 1,
      name: 'Staging',
      route: '/grid'
    },
    {
      id: 2,
      name: 'Changes',
      route: '/grid/logs'
    },
    {
      id: 3,
      name: 'Production',
      route: '/grid/production'
    },
    {
      id: 4,
      name: 'Change History',
      route: '/grid/history'
    },
    // {
    //   id: 5,
    //   name: 'Duplicates',
    //   route: '/grid/duplicates'
    // },
  ];
  public tableSelector = new FormControl<any>(null);
  public deleteTooltip = '';
  public appUpdatedNeedReload: boolean = false;

  public historyConflictCounter$: Observable<any>;
  public historyChangesCounter$: Observable<any>;
  public disapproveCounter$: Observable<any>;
  public stageChangesCounter$: Observable<any>;
  public productionChangesCounter$: Observable<any>;
  public historyApprovedCounter$: Observable<any>;

  public availableRam$: Observable<any>;
  public availableRam: number = 0;

  // Disk/RAM readout next to the version string, with the full breakdown in a
  // tooltip. Fed by the API's 10s websocket 'memory' tick.
  public systemStats$: Observable<any>;

  // Who else is working in the app, so nobody starts a sync/import on top of
  // someone else. Same tick as the stats above.
  public presence$: Observable<any>;

  public stageSelectedItemsCount: number = 0;
  public productionSelectedItemsCount: number = 0;
  public changesSelectedItemsCount: number = 0;
  public historySelectedItemsCount: number = 0;

  public stageFilterIsActive: boolean = false;
  public productionFilterIsActive: boolean = false;
  public changesFilterIsActive: boolean = false;
  public historyFilterIsActive: boolean = false;

  public api_v: string = '';


  public productionNotSyncItemCount: number = 0;

  public ready: boolean = false;
  public appReady: boolean = false;

  public currentUrl: string = '';
  public showAdminSettings = false;
  public title_aiConflictCounter: number = 0;
  public title_aiConflictPids: any = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private gridService: GridService,
    private dialog: MatDialog,
    private sharedService: SharedService,
    private httpService: HttpService,
    private toastService: ToastService,
    private infoService: InfoService,
    private webSocketService: WebSocketService,
    private localStorageService: LocalStorageService,
    private progressBarsService: ProgressBarsService
  ) {
    this.user$ = this.authService.getCurrentUser().pipe(
      shareReplay()
    );

    this.availableRam$ = this.gridService.getAvailableRam().pipe(
      shareReplay()
    );

    this.systemStats$ = this.gridService.getSystemStats().pipe(
      map((stats: any) => this.buildSystemStatsView(stats)),
      shareReplay()
    );

    this.presence$ = this.gridService.getPresence().pipe(
      map((entries: any) => this.buildPresenceView(entries)),
      shareReplay()
    );

    this.disapproveCounter$ = this.gridService.getDisapproveCount().pipe(
      shareReplay()
    );
    this.historyChangesCounter$ = this.gridService.getChangesHistoryCount().pipe(
      shareReplay()
    );
    this.stageChangesCounter$ = this.gridService.getChangesHistoryCount().pipe(
      shareReplay()
    );
    this.productionChangesCounter$ = this.gridService.getProductionChangesCount().pipe(
      shareReplay()
    );
    this.historyConflictCounter$ = this.gridService.getConflictsHistoryCount().pipe(
      shareReplay()
    );
    this.historyApprovedCounter$ = this.gridService.getApprovedHistoryCount().pipe(
      shareReplay()
    );

    this.gridService.stageSelectedItemsCount$.subscribe(resp => {
      if (resp === 1) {
        this.deleteTooltip = `Delete ${resp} Selected Product`;
      } else {
        this.deleteTooltip = `Delete ${resp} Selected Products`;
      }
      this.stageSelectedItemsCount = resp;
    });

    this.gridService.productionSelectedItemsCount$.subscribe(resp => {
      this.productionSelectedItemsCount = resp;
    });

    this.gridService.changesSelectedItemsCount$.subscribe(resp => {
      this.changesSelectedItemsCount = resp;
    });

    this.gridService.historySelectedItemsCount$.subscribe(resp => {
      this.historySelectedItemsCount = resp;
    });

    this.gridService.stageChangesCounter$.subscribe(resp => {
      this.stageModifiedProductsCounter = resp;
    });

    this.gridService.productionChangesCounter$.subscribe(resp => {
      this.productionModifiedProductsCounter = resp;
    });

    this.gridService.historyChangesCounter$.subscribe(resp => {
      this.stageModifiedProductsCounter = resp;
    });

    this.gridService.disapproveCounter$.subscribe(resp => {
      this.disapproveCounter = resp;
    });


    this.gridService.stageFilterIsActive$.subscribe(resp => {
      this.stageFilterIsActive = resp;
    });

    this.gridService.productionFilterIsActive$.subscribe(resp => {
      this.productionFilterIsActive = resp;
    });

    this.gridService.changesFilterIsActive$.subscribe(resp => {
      this.changesFilterIsActive = resp;
    });

    this.gridService.historyFilterIsActive$.subscribe(resp => {
      this.historyFilterIsActive = resp;
    });

    this.currentUrl = window.location.pathname;
    const currentView = this.tableSelectorValue.find((x: any) => x.route === window.location.pathname);
    this.currentTable.name = currentView?.name;
    this.tableSelector.setValue(currentView?.id);
    if (this.currentTable?.name?.length) {
      this.enableBottomBar = true;
    }

    if (this.currentUrl.includes('delete')) {
      this.enableBottomBar = true;
    }
  }

  // Completion verdicts are websocket one-shots — anyone not connected at
  // that instant (mid-refresh, closed tab) would never learn how the import
  // ended. On load, fetch the last summary and show it once if it's recent
  // and this browser hasn't displayed it yet.
  private checkLastImportSummary(): void {
    this.httpService.get(environment.API_PATH + '/import/lastSummary').subscribe((s: any) => {
      if (!s || !s.finishedAt) { return; }
      const seen = localStorage.getItem('lastImportSummarySeen');
      const ageMs = Date.now() - new Date(s.finishedAt).getTime();
      if (seen === s.finishedAt || ageMs > 60 * 60 * 1000) { return; }
      localStorage.setItem('lastImportSummarySeen', s.finishedAt);

      const processed = (s.count || 0).toLocaleString();
      let message: string;
      if (s.changed === 0) {
        message = `Last import finished: ${processed} rows processed — no values changed (data already matches the catalog)`;
      } else {
        message = `Last import finished: ${processed} rows processed — ${(s.changed || 0).toLocaleString()} products updated`;
      }
      if (s.durationMs > 0) {
        const secs = Math.round(s.durationMs / 1000);
        const m = Math.floor(secs / 60);
        message += ` — total import time ${m > 0 ? m + 'm ' : ''}${secs % 60}s`;
      }
      if (s.autoSync === 'started') {
        message += ' — Shopify sync started automatically';
      } else if (s.autoSync) {
        message += ` — auto-sync ${s.autoSync}`;
      }
      this.toastService.info(message, 'Import Data', { timeOut: 0, closeButton: true });
    });
  }

  private getApiVersion(): void {
    const v = this.localStorageService.getItem('api_version');
    if (v) {
      this.api_v = v.v;
    }
    this.httpService.get(environment.API_PATH + '/info/version').subscribe((res: any) => {
      this.localStorageService.setItem('api_version', res);
      this.api_v = res.v;
    });

    setInterval(() => {
      this.httpService.get(environment.API_PATH + '/info/version').subscribe((res: any) => {
        const api_version = this.localStorageService.getItem('api_version');
        if (api_version.v !== res.v) {
          this.appUpdatedNeedReload = true;
        }
      });
    }, 60000);
  }

  // Bytes -> human readable, matching how `df -h` / `free -h` present things so
  // the widget can be compared against the server at a glance.
  private formatBytes(bytes: any): string {
    if (bytes === null || bytes === undefined || isNaN(Number(bytes))) {
      return 'n/a';
    }
    const value = Number(bytes);
    if (value < 1024) {
      return value + ' B';
    }
    const units = ['KB', 'MB', 'GB', 'TB'];
    let scaled = value / 1024;
    let unit = 0;
    while (scaled >= 1024 && unit < units.length - 1) {
      scaled = scaled / 1024;
      unit++;
    }
    // Sub-10 values keep a decimal so "9.4 GB free" doesn't collapse to "9 GB".
    return (scaled < 10 ? scaled.toFixed(1) : scaled.toFixed(0)) + ' ' + units[unit];
  }

  // Thousands separators: these run to seven figures, and 494279 is unreadable.
  private formatCount(count: any): string {
    if (count === null || count === undefined || isNaN(Number(count))) {
      return 'n/a';
    }
    return Number(count).toLocaleString('en-US');
  }

  private formatGmcShare(eligible: any, total: any): string {
    const e = Number(eligible);
    const t = Number(total);
    if (!t || isNaN(e) || isNaN(t)) {
      return '';
    }
    return '  (' + Math.round((e / t) * 100) + '%)';
  }

  // The GMC figure is up to 30 minutes old, so say how old rather than let it
  // pass for a live number.
  private formatAge(measuredAt: any): string {
    const at = Number(measuredAt);
    if (!at || isNaN(at)) {
      return 'just now';
    }
    const minutes = Math.floor((Date.now() - at) / 60000);
    if (minutes < 1) {
      return 'just now';
    }
    if (minutes === 1) {
      return '1 minute ago';
    }
    return minutes + ' minutes ago';
  }

  // "40s ago" / "12m ago" / "1h 5m ago" -- entries stay listed for 2 hours, so
  // the age has to stay readable well past the hour mark.
  private formatSince(at: any): string {
    const stamp = Number(at);
    if (!stamp || isNaN(stamp)) {
      return '';
    }
    const seconds = Math.max(0, Math.floor((Date.now() - stamp) / 1000));
    if (seconds < 60) {
      return seconds + 's ago';
    }
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
      return minutes + 'm ago';
    }
    return Math.floor(minutes / 60) + 'h ' + (minutes % 60) + 'm ago';
  }

  // Builds the "who else is here" chip. Excludes the current user -- you are
  // not going to collide with yourself, and seeing your own name pad the count
  // makes the number misleading at a glance.
  private buildPresenceView(entries: any): any {
    if (!entries || !entries.length) {
      return null;
    }
    const currentUserId = this.authService.currentUserValue?._id;
    const others = entries.filter((entry: any) => entry.userId !== currentUserId);
    if (!others.length) {
      return null;
    }

    // Your own row is listed, marked "(you)", so you can sanity-check the
    // display against what you just did -- without it, seeing someone else's
    // action and not your own reads as your work being misattributed. It stays
    // out of the count, which is about who you might collide with.
    const mine = entries.filter((entry: any) => entry.userId === currentUserId)
      .map((entry: any) => ({ ...entry, name: (entry.name || 'You') + ' (you)' }));
    // Anyone actually working first, then most recent action.
    const rows = others.concat(mine).sort((a: any, b: any) => {
      if (!!a.working !== !!b.working) {
        return a.working ? -1 : 1;
      }
      return b.at - a.at;
    });

    const workingCount = others.filter((entry: any) => entry.working).length;
    const busy = others.filter((entry: any) => entry.working);

    // The heading states the collision-relevant fact in plain words, so the
    // status dots are reinforcement rather than a code the reader has to
    // decipher. That is what lets the legend go away entirely.
    let heading: string;
    if (workingCount === 0) {
      heading = 'Nobody is running anything';
    } else if (workingCount === 1) {
      heading = busy[0].name + ' is running something';
    } else {
      heading = workingCount + ' people are running something';
    }

    return {
      // Counts people actually doing something. Someone parked on a grid is in
      // the list but must not inflate this -- the number exists to answer
      // "is it safe to start a sync right now".
      label: workingCount > 0 ? workingCount + ' running' : rows.length + ' online',
      highlight: workingCount > 0,
      heading,
      subheading: rows.length + (rows.length === 1 ? ' person online' : ' people online'),
      rows: rows.map((entry: any) => ({
        name: entry.name || 'Unknown',
        working: !!entry.working,
        // action is null when all we have seen are background polls, so say
        // that rather than inventing an activity or leaving a blank cell.
        action: entry.action || 'No recent activity',
        when: entry.at ? this.formatSince(entry.at) : ''
      }))
    };
  }

  // Turns the raw byte payload into the label + tooltip the template renders.
  // Returns null until the first tick arrives so the template can hide the
  // readout rather than flash "n/a".
  private buildSystemStatsView(stats: any): any {
    if (!stats || !stats.diskTotal) {
      return null;
    }

    const services = stats.services || {};
    const serviceRows = ['api', 'sync', 'feed', 'ws']
      .filter((name: string) => services[name] !== null && services[name] !== undefined)
      .map((name: string) => ({ name, value: this.formatBytes(services[name]) }));

    // Memory percentage uses used-vs-total so the meter reads the same way as
    // the disk one; available (not free) is the honest denominator input.
    const memPct = stats.memTotal
      ? Math.round((stats.memUsed / stats.memTotal) * 100)
      : 0;

    const hasGmc = stats.gmcBhs !== null && stats.gmcBhs !== undefined;

    return {
      // Free space is what you act on, so it leads; the percentage gives it context.
      label: this.formatBytes(stats.diskFree) + ' free',
      gmcLabel: hasGmc ? this.formatCount(stats.gmcBhs) : null,
      // Turns amber at 85% and red at 95% -- at ~50GB/month of uploads growth,
      // 85% is roughly a month of runway left.
      warn: stats.diskUsedPct >= 85 && stats.diskUsedPct < 95,
      critical: stats.diskUsedPct >= 95,
      disk: {
        pct: stats.diskUsedPct,
        used: this.formatBytes(stats.diskUsed),
        free: this.formatBytes(stats.diskFree),
        total: this.formatBytes(stats.diskTotal),
        uploads: (stats.uploadsBytes === null || stats.uploadsBytes === undefined)
          ? null
          : this.formatBytes(stats.uploadsBytes),
        uploadFiles: this.formatCount(stats.uploadsFiles)
      },
      memory: {
        pct: memPct,
        used: this.formatBytes(stats.memUsed),
        available: this.formatBytes(stats.memAvailable),
        total: this.formatBytes(stats.memTotal),
        services: serviceRows
      },
      gmc: hasGmc ? {
        bhs: this.formatCount(stats.gmcBhs),
        mws: this.formatCount(stats.gmcMws),
        total: this.formatCount(stats.productsTotal),
        share: this.formatGmcShare(stats.gmcBhs, stats.productsTotal).trim(),
        // A 30-minute cached figure shown bare reads as live, so it is dated.
        measured: this.formatAge(stats.gmcMeasuredAt)
      } : null
    };
  }

  // Which meter colour a percentage earns. Shared by disk and memory so the
  // two read on the same scale.
  public meterState(pct: number): string {
    if (pct >= 95) {
      return 'is-critical';
    }
    if (pct >= 85) {
      return 'is-warn';
    }
    return '';
  }

  // Hover/focus opens a panel; only one at a time. Kept as a single field
  // rather than a boolean each so opening one closes the others for free.
  public openPanel: string | null = null;

  public gmcHistory: any = null;
  private gmcHistoryFetchedAt = 0;

  public showPanel(panel: string): void {
    this.openPanel = panel;
    if (panel === 'system') {
      this.loadGmcHistory();
    }
  }

  // Fetched lazily on first open rather than on the 10s tick: the series only
  // changes when the 30-minute recount writes a new sample, so polling it would
  // be pure waste. Re-fetched at most every 5 minutes while the app stays open.
  private loadGmcHistory(): void {
    if (this.gmcHistory && Date.now() - this.gmcHistoryFetchedAt < 5 * 60 * 1000) {
      return;
    }
    this.gmcHistoryFetchedAt = Date.now();
    this.httpService.get(environment.API_PATH + '/info/gmc-history?days=30').subscribe(
      (res: any) => {
        this.gmcHistory = this.buildGmcHistoryView(res);
      },
      () => {
        // Leave whatever we had; the panel simply omits the history block.
      }
    );
  }

  // Turns the daily series into a sparkline path plus the figures beside it.
  // Returns null until there is more than one day, because a single point is a
  // dot, not a trend, and drawing it would imply a history that does not exist.
  private buildGmcHistoryView(res: any): any {
    if (!res || !res.points || res.points.length === 0) {
      return null;
    }
    const values = res.points
      .map((p: any) => p.bhs)
      .filter((v: any) => typeof v === 'number');
    if (values.length < 2) {
      return {
        collecting: true,
        days: res.allTime ? res.allTime.days : values.length
      };
    }

    const min = Math.min(...values);
    const max = Math.max(...values);
    // An unchanged count has no range to scale against. Drawing it with the
    // usual formula pins every point to the baseline, which reads as "fell to
    // zero" rather than "held steady" -- so a flat series is drawn mid-height.
    const flat = max === min;
    const span = max - min;
    const width = 120;
    const height = 26;
    const step = width / (values.length - 1);

    const coords = values.map((v: number, i: number) => {
      const x = +(i * step).toFixed(2);
      const y = flat
        ? height / 2
        : +(height - ((v - min) / span) * height).toFixed(2);
      return { x, y };
    });

    const line = coords.map((c: any, i: number) =>
      (i === 0 ? 'M' : 'L') + c.x + ' ' + c.y).join(' ');
    // Closed back along the baseline so the area can be filled under the line.
    const area = line + ' L' + width + ' ' + height + ' L0 ' + height + ' Z';
    const lastPoint = coords[coords.length - 1];

    const change = res.window ? res.window.change : null;

    return {
      collecting: false,
      line,
      area,
      lastX: lastPoint.x,
      lastY: lastPoint.y,
      width,
      height,
      days: values.length,
      high: this.formatCount(res.window ? res.window.high : null),
      low: this.formatCount(res.window ? res.window.low : null),
      allTimeHigh: this.formatCount(res.allTime ? res.allTime.bhsHigh : null),
      allTimeLow: this.formatCount(res.allTime ? res.allTime.bhsLow : null),
      change: change === null || change === undefined
        ? null
        : (change > 0 ? '+' : '') + this.formatCount(change),
      changeUp: change > 0,
      changeDown: change < 0
    };
  }

  public hidePanel(panel: string): void {
    if (this.openPanel === panel) {
      this.openPanel = null;
    }
  }

  ngOnInit(): void {
    this.getApiVersion();
    this.checkLastImportSummary();

    // Feed the Syncing... button a live percent from whichever pipeline
    // phase is currently reporting.
    this.progressBarsService.importProgress$.subscribe((p: any) => {
      if (p?.isActive && p.percentage >= 0) {
        this.megaBtnPercent = p.percentage;
      }
    });
    this.progressBarsService.syncProgress$.subscribe((p: any) => {
      if (p?.totalItems > 0) {
        this.megaBtnPercent = p.percentage || 0;
      }
    });
    // setInterval(() => {
      // this.infoService.update();
    // }, 18000);

    // setInterval(() => {
      // this.infoService.getChangedStageProductsCounter();
    // }, 20000);

    // setInterval(() => {
      // this.infoService.getInfoMessage();
    // }, 20000);

    setTimeout(() => {
      this.httpService.get(environment.API_PATH + '/product/title_ai_conflicts').subscribe((res: any) => {
        this.title_aiConflictCounter = res.count;
        this.title_aiConflictPids = res.pid;
      });
    }, 1000)

    // Re-enable Update & Sync / Push to production once the backend reports the
    // push phase is actually complete (the HTTP response returns long before).
    this.infoService.pushToProductionComplete.subscribe(done => {
      if (done) {
        this.pushToProductionPending = false;
      }
    });

    this.infoService.$appReady.subscribe(ready => {
      if (ready !== null) {
        this.appReady = ready;
        this.httpService.get(environment.API_PATH + '/info').subscribe((res: any) => {});
        // this.webSocketService.send({});
        // console.log('this.appReady', this.appReady);
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.currentTable = this.tableSelectorValue.find(x => x.route === event.url);
        if (this.currentTable) {
          this.enableBottomBar = true;
          this.tableSelector.setValue(this.currentTable.id);
        } else if (this.currentUrl.includes('delete')) {
          this.enableBottomBar = true;
        } else {
          this.enableBottomBar = false;
        }
      }
    });
    this.ready = true;
    // setInterval(() => {
    //   this.getTEMPCOUNTER();
    // }, 7000);
    // this.getTEMPCOUNTER();
    this.user$.subscribe(res => {
      if (res && res.access.level === 1) {
        this.showAdminSettings = true;
      //   const toolPanel: any = {
      //     id: 'adminPanel',
      //     labelDefault: 'Admin',
      //     labelKey: 'customStats',
      //     iconKey: 'columnMoveMove',
      //     toolPanel: AdminToolPanelComponent,
      //     width: 400,
      //     maxWidth: 400,
      //   }
      //
      //   this.sideBar.toolPanels.push(toolPanel);
      //   setTimeout(() => {
      //     this.gridService.gridApi?.refreshToolPanel();
      //     this.gridService.gridApi?.setSideBar(this.sideBar);
      //   }, 500);
      } else {
        this.showAdminSettings = false;
      }
    });
  }

  public showConflictRecords(): void {
    this.gridService.changesGridApi?.setFilterModel(null);
    this.gridService.changesGridApi?.setFilterModel({
      status: {
        filterType: 'text',
        type: 'contains',
        filter: [50]
      }
    });
  }

  public showReadyTitleAiProducts() {
    this.httpService.post(environment.API_PATH + '/ai/showReadyTitleAiProducts', {}).subscribe(resp => {
      this.gridService.gridApi?.setFilterModel({
        product_id: {
          filterType: 'text',
          type: 'contains',
          filter: resp.pid.join(',')
        }
      });
    });
  }

  public showTitleAiConflictProducts() {
    this.gridService.gridApi?.setFilterModel({
      product_id: {
        filterType: 'text',
        type: 'contains',
        filter: this.title_aiConflictPids.join(',')
      }
    });
  }

  public approveAllChangesPending = false;
  public approveAllChanges(): void {
    if (!this.approveAllChangesPending) {
      this.approveAllChangesPending = true;
      this.httpService.post(environment.API_PATH + '/changes/confirm', {}).subscribe(resp => {
        if (resp.error) {
          this.toastService.info(resp.error);
          setTimeout(() => {
            this.approveAllChangesPending = false;
          }, 3000);
        } else {
          this.infoService.update();
          setTimeout(() => {
            this.approveAllChangesPending = false;
          }, 8000);
        }
      });
    }
  }

  public disapproveAllChangesPending = false;
  public disapproveAllChanges(): void {
    if (confirm('Are you sure you want to disapprove all changes?\nAll changes will be lost')) {
      if (!this.disapproveAllChangesPending) {
        this.disapproveAllChangesPending = true;
        this.httpService.post(environment.API_PATH + '/changes/reject', {}).subscribe(resp => {
          if (resp.error) {
            this.toastService.info(resp.error);
            setTimeout(() => {
              this.disapproveAllChangesPending = false;
            }, 3000);
          } else {
            this.infoService.update();
            setTimeout(() => {
              this.disapproveAllChangesPending = false;
            }, 8000);
          }
        });
      }
    }
  }

  public pushToProductionPending = false;
  // Live percent for the Syncing... button label — mirrors whichever pipeline
  // phase is reporting (confirm/push/feed ride importProgress; the Shopify
  // sync rides syncProgress). Without it the disabled button reads as hung.
  public megaBtnPercent: number | null = null;
  public pushToProduction(): void {
    // this.httpService.get(environment.API_PATH + '/queues').subscribe((res: any) => {
    //   if (res.shopify_sync.lock === false && res.push_to_production.lock === false) {
        if (!this.pushToProductionPending) {
          if (window.confirm('Are you sure?')) {
            this.pushToProductionPending = true;
            this.gridService.changesGridApi?.showLoadingOverlay();
            this.toastService.info('Pushing approved changes to production... This can take several minutes on large sets.');
            this.httpService.post(environment.API_PATH + '/changes/push', {}).subscribe(resp => {
              if (resp.error) {
                this.toastService.info(resp.error);
                setTimeout(() => {
                  this.pushToProductionPending = false;
                  this.gridService.changesGridApi?.hideOverlay();
                }, 500);
              }
              // On success, pending stays true until the push-to-production
              // complete WS event re-enables the buttons.
            });
          }
        }
    //   } else {
    //     this.toastService.info('Synchronization with shopify is in progress. Please try again later.');
    //   }
    // });

  }

  public pushAllAndSync(): void {
    // this.httpService.get(environment.API_PATH + '/queues').subscribe((res: any) => {
    //   if (res.shopify_sync.lock === false && res.push_to_production.lock === false) {
        if (!this.pushToProductionPending) {
          const dialogRef = this.dialog.open(SyncModeDialogComponent, { width: '520px' });
          dialogRef.afterClosed().subscribe((syncMode: 'queue' | 'bulk' | undefined) => {
            if (!syncMode) {
              return; // cancelled
            }
            this.pushToProductionPending = true;
            this.gridService.changesGridApi?.showLoadingOverlay();
            // Immediate feedback — confirming/pushing a large set takes minutes and
            // the HTTP response alone doesn't mean the work is done.
            this.toastService.info(`Confirming and syncing all changes (${syncMode === 'bulk' ? 'bulk' : 'standard queue'} sync)... This can take several minutes on large sets. The button stays disabled until the push completes.`);

            this.httpService.post(environment.API_PATH + '/changes/omg', { syncMode }).subscribe(resp => {
              if (resp.error) {
                this.toastService.info(resp.error);
                setTimeout(() => {
                  this.pushToProductionPending = false;
                }, 2000);
              } else {
                // Keep pending until the push-to-production complete WS event —
                // the HTTP response returns while the server is still working.
                this.toastService.info(resp.message);
              }
            });
          });
        }
    //   } else {
    //     this.toastService.info('Synchronization with shopify is in progress. Please try again later.');
    //   }
    // });
  }

  public selectTableView(table: any): void {
    if (this.tableSelector.value === table.id) {
      return;
    }
    this.tableSelector.setValue(table.id);
    this.changeTableView({ value: table.id });
  }

  public changeTableView(event: any): void {
    console.log('event', event);
    this.currentTable = this.tableSelectorValue.find(x => x.id === event.value);
    this.router.navigateByUrl(this.currentTable.route);
  }

  public backToGrid(): void {
    this.router.navigate(['/grid']);
  }

  public adminSettings(): void {
    this.router.navigate(['/admin']);
  }

  public userSettings(): void {
    this.router.navigate(['/user']);
  }

  public goToDelete(): void {
    this.router.navigate(['/delete']);
  }

  public goToUploads(): void {
    this.router.navigate(['/uploads']);
  }

  public logout(): void {
    if (window.confirm("Do you really want to leave?")) {
      this.authService.logout(true);
    }
  }

  deleteFilteredProducts(): void {
    const filterModel = this.gridService.gridApi?.getFilterModel();
    if (confirm('Delete?')) {
      this.httpService.post(environment.API_PATH + '/product/delete-filtered', {
        filterModel
      }).subscribe((res: any) => {
        this.stageSelectedItemsCount = 0;
        setTimeout(() => {
          this.gridService.gridApi?.refreshServerSideStore({purge: true});
        }, 3000);
        this.gridService.gridApi?.clearRangeSelection();
      });
    }
  }

  deleteSelectedProducts(): void {
    const ids = this.gridService.gridApi?.getSelectedRows().map((r: any) => r._id);
    // const ids = this.gridService.productionGridApi?.getSelectedRows().map((r: any) => r._id);
    if (confirm('Delete?')) {
      this.httpService.post(environment.API_PATH + '/product/delete', {
        product_id: ids
      }).subscribe((res: any) => {
        this.stageSelectedItemsCount = 0;
        setTimeout(() => {
          this.gridService.gridApi?.refreshServerSideStore({purge: true});
        }, 3000);
        this.gridService.gridApi?.clearRangeSelection();
      });
    }
  }

  importDialog() {
    this.dialog.open(ImportDiaglogComponent, {
      width: '90%',
      maxWidth: '750px',
      disableClose: true,
      data: {}
    });
  }

  selectedExportDialog() {
    let selectedRows: any = null;
    if (this.currentTable.name === 'Production') {
      selectedRows = this.gridService.productionGridApi?.getSelectedRows()
    } else if (this.currentTable.name === 'Staging') {
      selectedRows = this.gridService.gridApi?.getSelectedRows()
    } else if (this.currentTable.name === 'Changes') {
      selectedRows = this.gridService.changesGridApi?.getSelectedRows()
    } else if (this.currentTable.name === 'Change History') {
      selectedRows = this.gridService.historyGridApi?.getSelectedRows()
    }

    const selectedIds = selectedRows.map((x: any) => x._id);

    this.dialog.open(ExportDiaglogComponent, {
      width: '90%',
      maxWidth: '675px',
      // maxHeight: '500px',
      disableClose: true,
      data: {
        selectedIds,
        currentTable: this.currentTable?.name,
        columns: this.sharedService.columnDefs.map((col) => {
          return {
            field: col.field,
            name: col.headerName
          }
        })
      }
    });
  }

  filteredExportDialog() {
    let filterModel: any = {};
    if (this.currentTable.name === 'Production') {
      filterModel = this.gridService.productionGridApi?.getFilterModel();
    } else if (this.currentTable.name === 'Staging') {
      filterModel = this.gridService.gridApi?.getFilterModel();
    } else if (this.currentTable.name === 'Changes') {
      filterModel = this.gridService.changesGridApi?.getFilterModel();
    } else if (this.currentTable.name === 'Change History') {
      filterModel = this.gridService.historyGridApi?.getFilterModel();
    }

    this.dialog.open(ExportDiaglogComponent, {
      width: '90%',
      maxWidth: '675px',
      // maxHeight: '500px',
      disableClose: true,
      data: {
        filterModel,
        currentTable: this.currentTable?.name,
        columns: this.sharedService.columnDefs.map((col) => {
          return {
            field: col.field,
            name: col.headerName
          }
        })
      }
    });
  }

  scheduleFilteredExportDialog() {
    let filterModel: any = {};
    let sortModel: any = [];
    let tagFilter: any = null;
    let tableType: 'stage' | 'production' | 'changes' = 'stage';

    if (this.currentTable.name === 'Production') {
      filterModel = this.gridService.productionGridApi?.getFilterModel() || {};
      const columnState = this.gridService.productionColumnApi?.getColumnState() || [];
      sortModel = columnState.filter((col: any) => col.sort).map((col: any) => ({ colId: col.colId, sort: col.sort, sortIndex: col.sortIndex }));
      tableType = 'production';
    } else if (this.currentTable.name === 'Staging') {
      filterModel = this.gridService.gridApi?.getFilterModel() || {};
      const columnState = this.gridService.columnApi?.getColumnState() || [];
      sortModel = columnState.filter((col: any) => col.sort).map((col: any) => ({ colId: col.colId, sort: col.sort, sortIndex: col.sortIndex }));
      tableType = 'stage';
    } else if (this.currentTable.name === 'Changes') {
      filterModel = this.gridService.changesGridApi?.getFilterModel() || {};
      const columnState = this.gridService.changesColumnApi?.getColumnState() || [];
      sortModel = columnState.filter((col: any) => col.sort).map((col: any) => ({ colId: col.colId, sort: col.sort, sortIndex: col.sortIndex }));
      tableType = 'changes';
    }

    // Get tag filter from local storage if available
    try {
      const tagFilterData = this.localStorageService.getTagFilter();
      if (tagFilterData) {
        tagFilter = tagFilterData;
      }
    } catch (e) {
      console.warn('Failed to get tag filter:', e);
    }

    const selectedColumns = this.sharedService.columnDefs
      .filter((col) => col.field) // Only include columns with field defined
      .map((col) => col.field as string);

    const dialogRef = this.dialog.open(ScheduleExportDialogComponent, {
      width: '90%',
      maxWidth: '700px',
      disableClose: true,
      data: {
        filterModel,
        sortModel,
        selectedColumns,
        tableType,
        tagFilter
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastService.success('Scheduled export created successfully. View it in Scheduled Events.');
      }
    });
  }

  startSelectedGptFineTuneModel(): void {
    const selectedProducts: any = this.gridService.gridApi?.getSelectedRows();
    const ids = selectedProducts.map((x: any) => x.product_id);

    this.httpService.post(environment.API_PATH + '/ai/restartSelectedGptFineTuneModelV2', {ids}).subscribe(response => {
      // this.gridService.aiFineTuneGptCompleteEvent.next(true);
    });
  }

  showReadyProducts(): void {
    this.httpService.post(environment.API_PATH + '/ai/showReadyProducts', {}).subscribe((res: any) => {
      this.gridService.gridApi?.setFilterModel({
        product_id: {
          filterType: 'text',
          type: 'contains',
          filter: res.filter
        }
      });
    });
  }

  getAiTitleForFiltered(): void {
    const filterModel = this.gridService.gridApi?.getFilterModel();
    console.log('filterModel', filterModel);
    const body = { filterModel };
    this.httpService.post(environment.API_PATH + '/ai/getAiTitleByFilteredProduct', body).subscribe((res: any) => {
      // this.toastService.info(res.message);
    });
  }

  regenerateFilteredCollections(): void {
    const filterModel = this.gridService.gridApi?.getFilterModel();
    console.log('filterModel', filterModel);
    const body = { filterModel };
    this.httpService.post(environment.API_PATH + '/ai/generate-products-collections-filtered', body).subscribe((res: any) => {
      // this.toastService.info(res.message);
    });
  }
  regenerateSelectedCollections(): void {
    const selected: any = this.gridService.gridApi?.getSelectedRows();
    const pids = selected.map((x: any) => x._id);
    console.log('selectedIds', pids);
    if (pids.length) {
      this.httpService.post(environment.API_PATH + '/ai/generate-products-collections', {pids}).subscribe((res: any) => {

      });
    }
  }

  bulkEditSelectedDialog(): void {
    const selectedRows: any = this.gridService.gridApi?.getSelectedRows();
    const selectedIds = selectedRows.map((x: any) => x._id);

    this.httpService.post(environment.API_PATH + '/product/stage/edit/bulkStart', {
      ids: selectedIds,
      user: {
        _id: this.authService.currentUserValue._id,
        name: this.authService.currentUserValue.name
      }
    }).subscribe(res => {
      this.dialog.open(BulkEditDialogComponent, {
        id: 'bulkEditDialog',
        width: '100vw',
        maxWidth: '98vw',
        height: '98vh',
        data: {
          type: 'selected',
          rows: selectedIds
        }
      }).afterClosed().subscribe(() => {
        this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
      });
    });
  }

  asmExportSelected(): void {}

  asmExportFiltered(): void {}

  gmcOpenMWSFeed(): void {
    window.open(`https://webdb-api-sync.blackhawksupply.com/public/mws`, '_blank', 'noreferrer');
  }
  gmcOpenBHSFeed(): void {
    window.open(`https://webdb-api-sync.blackhawksupply.com/public`, '_blank', 'noreferrer');
  }

  gmcMWSFeed(): void {
    const postData = {};
    this.httpService.post(environment.API_PATH + '/gmc', postData).subscribe((res: any) => {
      console.log('gmcFeed', res);
    });
  }
  gmcBHSFeed(): void {
    const postData = {};
    this.httpService.post(environment.API_PATH + '/gmc', postData).subscribe((res: any) => {
      console.log('gmcFeed', res);
    });
  }

  bulkEditFilterDialog(): void {
    const filterModel = this.gridService.gridApi?.getFilterModel();
    const body = {startRow: 0, endRow: 100, rowGroupCols: [], groupKeys: [], filterModel, sortModel: []};

    this.httpService.post(environment.API_PATH + '/product/stage/edit/bulkStart', {
      ids: null,
      filterModel: filterModel,
      user: {
        _id: this.authService.currentUserValue._id,
        name: this.authService.currentUserValue.name
      }
    }).subscribe((res) => {
      this.dialog.open(BulkEditDialogComponent, {
        id: 'bulkEditDialog',
        width: '100vw',
        maxWidth: '98vw',
        height: '98vh',
        data: {
          type: 'filtered',
          rows: [],
          body
        }
      }).afterClosed().subscribe(() => {
        this.httpService.post(environment.API_PATH + '/product/stage/edit/stop', {}).subscribe((res: any) => {});
      });
    });
  }

  stageResetColumnState(): void {
    this.gridService.columnApi?.resetColumnState();
  }


  changesResetColumnState(): void {
    this.gridService.changesColumnApi?.resetColumnState();
  }

  viewAllChangesProductOnStage() {
    this.gridService.gridApi?.setFilterModel(null);
    this.gridService.gridApi?.setFilterModel({
      status: {
        filterType: 'text',
        type: 'contains',
        filter: [15, 20, 30, 40]
      }
    });
  }

  viewAllChangesProductOnProduction() {
    this.gridService.productionGridApi?.setFilterModel(null);
    this.gridService.productionGridApi?.setFilterModel({
      status: {
        filterType: 'text',
        type: 'contains',
        filter: [20, 30, 40, 80]
      }
    });
  }

  clearAllFilters(table: string) {
    if (table === 'stage') {
      this.gridService.gridApi?.setFilterModel(null);
    } else if (table === 'production') {
      this.gridService.productionGridApi?.setFilterModel(null);
    } else if (table === 'changes') {
      this.gridService.changesGridApi?.setFilterModel(null);
    } else {
      this.gridService.historyGridApi?.setFilterModel(null);
    }
  }

  goToCollections(): void {
    this.router.navigate(['/grid/collections']);
  }
  resetColumnState(table: string): void {
    if (table === 'stage') {
      this.gridService.columnApi?.resetColumnState();
    } else if (table === 'production') {
      this.gridService.productionColumnApi?.resetColumnState();
    } else if (table === 'changes') {
      this.gridService.changesColumnApi?.resetColumnState();
    } else {
      this.gridService.historyColumnApi?.resetColumnState();
    }
  }

  createFeedFiltered(): void {
    let filterModel = this.gridService.productionGridApi?.getFilterModel();
    const body = {startRow: 0, endRow: 100, rowGroupCols: [], groupKeys: [], filterModel, sortModel: []};
    this.httpService.post(environment.API_PATH + '/feed/filtered', body).subscribe((res: any) => {
      if (res.error) {
        this.toastService.info(res.error);
      } else {
        this.toastService.info(res.message, '', {timeOut: 3000});
      }
    });
  }

  handleKey(event: any) {
    this.showForceButton = !!event.shiftKey;
  }

  createFeedSelected(ids = null): void {
    let selectedIds = ids;
    if (ids === null) {
      const selectedRows: any = this.gridService.productionGridApi?.getSelectedRows();
      selectedIds = selectedRows.map((x: any) => x._id);
    }
    this.gridService.productionGridApi?.showLoadingOverlay();
    this.httpService.post(environment.API_PATH + '/feed/selected', {
      ids: selectedIds
    }).subscribe((res: any) => {
      if (res.error) {
        this.toastService.info(res.error);
        this.gridService.productionGridApi?.hideOverlay();
      } else {
        this.gridService.productionGridApi?.deselectAll();
        this.toastService.info(res.message, '', {timeOut: 3000});
        this.gridService.productionGridApi?.hideOverlay();
      }
    });
  }

  forceCreateFeedSelected(): void {
    const selectedRows: any = this.gridService.productionGridApi?.getSelectedRows();
    const selectedIds = selectedRows.map((x: any) => x._id);

    this.gridService.productionGridApi?.showLoadingOverlay();
    this.httpService.post(environment.API_PATH + '/feed/forceSelected', {ids: selectedIds}).subscribe((res: any) => {
      if (res.error) {
        this.toastService.info(res.error);
        this.gridService.productionGridApi?.hideOverlay();
      } else {
        this.toastService.info(res.message, '', {timeOut: 3000});
        this.gridService.productionGridApi?.deselectAll();
        this.gridService.productionGridApi?.hideOverlay();
      }
    });
  }

  forceCreateFeedFiltered(): void {
    let filterModel = this.gridService.productionGridApi?.getFilterModel();
    const body = {startRow: 0, endRow: 100, rowGroupCols: [], groupKeys: [], filterModel, sortModel: []};
    this.httpService.post(environment.API_PATH + '/feed/force', body).subscribe((res: any) => {
      if (res.error) {
        this.toastService.info(res.error);
      } else {
        this.toastService.info(res.message, '', {timeOut: 3000});
        this.gridService.productionGridApi?.deselectAll();
      }
    });
  }

  createFeedChanged(): void {
    this.httpService.get(environment.API_PATH + '/product/all-changes').subscribe((res: any) => {
      if (res.error) {
        this.toastService.info(res.error);
      } else {
        this.createFeedSelected(res.map((x: any) => x._id));
        this.productionNotSyncItemCount = 0;
      }
    });
  }
  logResults(
    transaction: ServerSideTransaction,
    result?: ServerSideTransactionResult
  ) {
    console.log(
      '[Example] - Applied transaction:',
      transaction,
      'Result:',
      result
    );
  }

  test() {
    this.dialog.open(FilterFromFileDialogComponent, {
      width: '192px',
      panelClass: 'filterFromFileDialogComponentClass',
      maxWidth: '152px',
      height: '103px',
      data: {
        environment: this.currentUrl.includes('delete') ? 'delete' : this.currentTable.name,
        rows: [],
      }
    });
  }

  pendingRestart: boolean = false;
  restartApi(): void {
    if (confirm('Are you sure?')) {
      this.pendingRestart = true;
      this.gridService.gridApi?.showLoadingOverlay();
      this.gridService.productionGridApi?.showLoadingOverlay();
      this.gridService.changesGridApi?.showLoadingOverlay();
      this.gridService.historyGridApi?.showLoadingOverlay();
      this.httpService.post(environment.API_PATH + '/product/restart', {}).subscribe((res: any) => {});
    }
  }

  expressionBuilderDialog(): void {
    this.dialog.open(ExpressionsBuilderDialogComponent, {
      width: '100%',
    });
  }

  protected readonly environment = environment;
}
